import { ReportConfig, ReportConfigCreateRequest, ReportConfigUpdateRequest } from "@bluefalcon/clients-management-client-fetch";
import { faTrashCan } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState, useEffect } from "react";
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalCloseButton,
    ModalBody,
    ModalFooter,
    Button,
    FormControl,
    FormLabel,
    Input,
    IconButton,
} from "@chakra-ui/react";

type AddEditReportConfigModalProps = {
    isOpen: boolean;
    reportConfig?: ReportConfig;
    handleAddReportConfig: (data: ReportConfigCreateRequest) => Promise<void>;
    handleEditReportConfig: (reportConfigId: number, data: ReportConfigUpdateRequest) => Promise<void>;
    handleDeleteReportConfig: (reportConfigId: number) => Promise<void>;
    onClose: () => void;
};

export const AddEditReportConfigModal = ({
    isOpen,
    reportConfig,
    handleAddReportConfig,
    handleEditReportConfig,
    handleDeleteReportConfig,
    onClose,
}: AddEditReportConfigModalProps) => {
    const [name, setName] = useState(reportConfig?.name ?? "");

    useEffect(() => {
        setName(reportConfig?.name ?? "");
    }, [reportConfig]);

    const handleSubmit = async () => {
        if (reportConfig && name.trim()) {
            await handleEditReportConfig(reportConfig.id, { name: name.trim() });
        } else if (name.trim()) {
            await handleAddReportConfig({ name: name.trim() });
        }
        onCloseModal();
    };

    const handleDelete = async () => {
        if (reportConfig) {
            await handleDeleteReportConfig(reportConfig.id);
        }
        onCloseModal();
    };

    const onCloseModal = () => {
        setName("");
        onClose();
    };

    return (
        <Modal isOpen={isOpen} onClose={onCloseModal}>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>{reportConfig ? "Edit Report Config" : "Add Report Config"}</ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                    <FormControl mb={4}>
                        <FormLabel htmlFor="name">Name</FormLabel>
                        <Input
                            id="name"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            placeholder="Enter name"
                        />
                    </FormControl>
                </ModalBody>

                <ModalFooter>
                    {reportConfig && (
                        <IconButton
                            aria-label="Delete Report Config"
                            icon={<FontAwesomeIcon icon={faTrashCan} />}
                            variant="outline"
                            onClick={handleDelete}
                            mr="auto"
                        />
                    )}
                    <Button variant="outline" onClick={onCloseModal}>
                        Close
                    </Button>
                    <Button colorScheme="teal" ml={3} onClick={handleSubmit}>
                        {reportConfig ? "Edit Report Config" : "Add Report Config"}
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
};
